// Copyright (c) StrangeBee 2024

import UserAvatar from '@Atoms/UserAvatar/UserAvatar';
import React, { ReactElement } from 'react';
import { OrganisationOutput } from 'thehive-sdk';

import './OrgLayoutTitle.scss';

interface OrgLayoutTitleProps {
    data: OrganisationOutput;
}

const OrgLayoutTitle = ({ data }: OrgLayoutTitleProps): ReactElement => {
    return (
        <div className="org-layout-title">
            <UserAvatar name={data.name} avatar={data.avatar} className="org-layout-title__avatar" />
            <span>{data.name}</span>
        </div>
    );
};

export default OrgLayoutTitle;
